import { ROUTE_URL, ARTICLE_KEY, VISITOR_PRIVILEGES, MAP_STORE_ICON } from 'basic/config'

export * from 'basic/config'

ROUTE_URL.ABOUT = '/about'
ROUTE_URL.STREAM = '/stream'
ROUTE_URL.TOOLS = '/tools'

VISITOR_PRIVILEGES.SIGHTED = '_visitor_marketing_0';

export { ROUTE_URL }

export const HAS_CART = true
export const HAS_DELIVERY = true
export const HAS_MESSAGES = true

export const REACT_APP_INDEX_URL="/";

export const GOODS_CATEGORY_MENU = true;

export const VISITOR_REDIRECT = [
  { pathname: '/register', privileges: null, to: '/register/' },
  { pathname: '/dashboard', privileges: VISITOR_PRIVILEGES.STORE, to: process.env.REACT_APP_ADMIN_URL }
];
MAP_STORE_ICON.url = `${process.env.PUBLIC_URL}/assets/images/delivery.png`;

export const HAS_BINARY_FULLNAME = true;
